export default "__VITE_ASSET__82414e7a__"